import React from 'react'
import '../UI/Title.css'


export default function Title({title}) {
  return (
    <div className='title'>{title}</div>
  )
}
